;(function(){

	var
		$nav = $('.primary-nav'),
		topOffset = 99999,
		onResize = function() {
			topOffset = $site.header.get(0).getBoundingClientRect().height
				- $nav.get(0).getBoundingClientRect().height;
			onScroll();
		},
		onScroll = function() {
			if (site.width < 768) {
				return;
			}
			$nav.toggleClass('is-fixed', site.scroll.y >= topOffset);
		};

	if (!$nav.length) {
		return;
	}

	site.scroll.listener.header = onScroll;
	site.resize.header = onResize;

	onResize();

}());
